import { Delete } from "@mui/icons-material";
import { Button, Tooltip } from "@mui/material";
import { useRemoveDossierMutation } from "services/streamingApi/caseManager.api";
import { unwrappableActionSnackbarNotificationDecorator } from "utils/unwrappableActionSnackbarNotificationDecorator";
import { Dossier } from "types/Dossier";
import { useConfirm } from "material-ui-confirm";

export interface DossierRemoveButtonProps {
    dossier: Dossier;
}

export function DossierRemoveButton(props: DossierRemoveButtonProps) {
    const [removeDossier] = useRemoveDossierMutation();

    const confirm = useConfirm();

    return (
        <>
            <Tooltip title="Delete dossier">
                <Button
                    startIcon={<Delete />}
                    onClick={(event) => {
                        event.stopPropagation(); // Prevents parent onRowClick

                        confirm({
                            description: `Are you sure you want to remove dossier '${props.dossier.name}' created by ${props.dossier.createdBy}?`,
                            confirmationText: "Yes",
                            cancellationText: "No",
                        }).then((confirmResult) => {
                            if (confirmResult.confirmed) {
                                unwrappableActionSnackbarNotificationDecorator(
                                    removeDossier({
                                        id: props.dossier.id,
                                    }),
                                    `Dossier ${props.dossier.name} has been deleted`,
                                    `Failed to delete the dossier, please try again`,
                                    undefined,
                                    "info",
                                );
                            }
                        });
                    }}
                >
                    Remove
                </Button>
            </Tooltip>
        </>
    );
}
